import { render, staticRenderFns } from "./aiRecommendedSelectJob.vue?vue&type=template&id=f37b8dfa&scoped=true"
import script from "./aiRecommendedSelectJob.vue?vue&type=script&lang=js"
export * from "./aiRecommendedSelectJob.vue?vue&type=script&lang=js"
import style0 from "./aiRecommendedSelectJob.vue?vue&type=style&index=0&id=f37b8dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b8dfa",
  null
  
)

export default component.exports